module.exports = __webpack_public_path__ + "media/partners/renowacjafelg-bg-3bb4583a.png";